import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import DropdownItem from '@/components/DropdownItem';
import { filterAttachmentTransferable } from '../helper';
import Events from '../hooks/events';

const AttachmentTransferTools = ({
  attachment,
  category,
  code,
  disabled,
}) => {
  const intl = useIntl();
  const updateMetadata = Events.useUpdateDatasetAttachmentMetadata({ category, code });
  const { metadata, id: attachmentId } = attachment;

  return (
    <>
      <Dropdown.Header content={intl.formatMessage({ id: 'dataset.attachments.transferable.header' })} />
      {filterAttachmentTransferable(metadata).map(({ icon, name }) => (
        <DropdownItem
          disabled={disabled}
          icon={icon}
          key={`dataset_attachments_transferable_${name}`}
          onClick={() => updateMetadata({ attachmentId, metadata: { transferable: name } })}
          textId={`dataset.attachments.transferable.${name}`}
        />
      ))}
    </>
  );
};

export default AttachmentTransferTools;
